// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/ckeditor.scss
// module id = 40
// module chunks = 3